import i18n from 'i18next';

const changeI18nLanguage = async (languageISOCode) => {
  await i18n.changeLanguage(languageISOCode);
};

export { changeI18nLanguage };
